import { i18n } from '@/main';
import { shallowClones } from '@/utils/tools/utils';

// export interface IValidator {
//   key: string;
//   regExp: RegExp | null;
//   tips: any;
// }

// 必填
export const REQUIRED = {
  key: 'required',
  regExp: /^\s*$/g,
  tips: 'message.validator.required',
};
// 密码验证
export const VALIDATE_PASSWORD = {
  key: 'passwordRule',
  regExp: /^[~`!@#$%^&*()_=\-+{}|;:'"<,>.?\\/0-9A-z]*$/,
  tips: 'message.validator.passwordRule',
};
export const PASSWORD_LENGTH = {
  key: 'passwordLength',
  regExp: /^[\w\W]{8,20}$/,
  tips: 'message.validator.passwordLength',
};
export const PASSWORD_STRENGTH = {
  key: 'passwordStrength',
  regExp: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~`!@#$%^&*()_=\-+{}|;:'"<,>.?/])[\da-zA-Z~`!@#$%^&*()_=\-+{}|;:'"<,>.?/]*$/,
  tips: 'message.validator.passwordStrength',
};
// 邮箱验证
export const EMAIL = {
  key: 'email',
  regExp: /^[^@\u4e00-\u9fa5]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
  tips: 'message.validator.email',
};
// 验证输入框长度
export const STRING_LENGTH_256 = {
  key: 'length256',
  regExp: /^[\d\D]{0,256}$/,
  tips: 'message.validator.stringLength256',
};

export const STRING_LENGTH_50 = {
  key: 'length256',
  regExp: /^[\d\D]{0,50}$/,
  tips: 'message.validator.stringLength50',
};

export const LIMIT_LENGTH_CUSTOM = (length) => ({
  key: 'required',
  regExp: new RegExp(`^(?!.{0,${length}}$).+$`),
  tips: `长度限制${length}`,
});

export const VALIDATE_NUMBER_1_100 = {
  key: 'number',
  regExp: new RegExp('^(1|100|[1-9][0-9]?)$|^(100)$'),
  tips: 'message.validator.inputNumber1_100',
};

export const NUMBER = {
  key: 'number',
  regExp: /^\d+$/,
  tips: 'message.validator.inputNumber',
};

// 金额必须>=0，小数位最多支持输入两位
export const AMOUNT = {
  key: 'amount',
  regExp: /^(?:0|[1-9]\d*)(?:\.\d{0,2})?$/,
  tips: 'message.validator.amount',
};

// 金额支持正数负数0，小数位最多支持输入两位
export const AMOUNT_WITH_MINUS = {
  key: 'amount',
  regExp: /^-?(?:\d+|\d*\.\d{1,2})$/,
  tips: 'message.validator.amount_all',
};
// 身份证号码
export const ID_CARD = {
  key: 'id_card',
  // eslint-disable-next-line max-len
  regExp: /^(1[1-5]|2[1-3]|3[1-7]|4[1-6]|5[0-4]|6[1-5]|82|[7-9]1)[0-9]{4}(((19|20)[0-9]{2}(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((19|20)(0[48]|[2468][048]|[13579][26])0229)|(20000229))[0-9]{3}[0-9Xx]$/,
  tips: 'message.validator.idCard',
};
/**
 *  卡号长度要大于10
 */
export const CARD_LENGTH = {
  key: 'cardLength',
  regExp: /^[\w\W]{10,}$/,
  tips: 'message.validator.cardLength',
};

/**
 * 输入数字
 */
export const AllNumber = {
  key: 'cardNumber',
  regExp: /^[0-9]+$/,
  tips: 'message.validator.inputNumber',
};

export const OTHER_WORD = {
  key: 'name',
  regExp: /(^[ a-zA-Z]+$)/,
  tips: 'message.validator.inputWords',
};

export const PHONE_NUMBER = {
  key: 'phone',
  regExp: /^1\d{10}$/,
  tips: 'message.validator.inputPhone',
};

export const ENGLISH_WORD = {
  key: 'name',
  regExp: /(^[a-zA-Z]+$)/,
  tips: 'message.validator.inputWords',
};

export const ENGLISH_NAME = {
  key: 'en',
  regExp: /(^[a-zA-Z0-9.,\s]+$)/,
  tips: 'message.validator.inputEnglish',
};

// 英文字母、阿拉伯数字、空格
export const EN_NUMBER_SPACE = {
  key: 'enNumberSpace',
  regExp: /^[a-zA-Z0-9\s]+$/,
  tips: 'message.validator.enNumberSpace',
};

export const DATEFORMAT = {
  key: 'dateFormat',
  regExp: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[01])$/,
  tips: 'message.validator.dateFormat',
};

export const WEBSITE = {
  key: 'website',
  regExp: /^(http:\/\/|https:\/\/)/,
  tips: 'message.validator.website',
};

/**
   * @description 通过rules校验,返回一个校验函数
   * @param {Array} rules - 校验规则
   * @return {Function} 校验函数
   */
export const validateFns = (rules) => {
  return (rule, value, callback) => {
    let tip = '';
    rules.forEach((item) => {
      if (item.key === REQUIRED.key) {
        if (item.regExp && item.regExp.test(value)) {
          tip = item.tips ? i18n.t(item.tips) : '';
        }
      } else {
        if (item.regExp && !item.regExp.test(value) && !tip) {
          tip = item.tips ? i18n.t(item.tips) : '';
        }
      }
    });
    if (tip) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

export const setRequiredTip = (tip) => {
  const required = shallowClones(REQUIRED);
  required.tips = tip;
  return required;
};
export const luhnCheckCardNumber = function(cardNumber) {
  let total = 0;
  const cardNumLength = cardNumber.length;
  for (let i = 1; i <= cardNumLength; i++) {
    let num = parseInt(cardNumber.charAt(cardNumLength - i), 10);
    if (i % 2 === 0) {
      num *= 2;
      if (num < 10) {
        total += num;
      } else {
        const t1 = num.toString();
        total += parseInt(t1.charAt(0), 10) + parseInt(t1.charAt(1), 10);
      }
    } else {
      total += num;
    }
  }
  return total % 10 === 0;
};
